import React from 'react';
import FoodList from "../components/foodList/foodList";

const FoodGallery = () => {
  return (
    <section>
      <h1>Rosie&apos;s Food wish list</h1>
      <FoodList />
    </section>
  );
};

export default FoodGallery;
